import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';

import Grid from "@mui/material/Grid2";
import Select from 'react-select';
import { getInputProps } from 'pages/DashboardHelpers';
import { getModelHierarchy, updateModelHierarchy } from 'actions/userActions';

const formControlStyles = { display: 'block', width: '100%', marginBottom: '14px' };
const formFieldStyles = { control: (provided) => ({ ...provided, padding: '6px', borderRadius: "12px" }) };

const FormField = ({
  label, value, onChange, options, placeholder,
  isSelect = false, disabled = false, onMenuOpen
}) => (
  <Grid container spacing={2} alignItems="center" sx={formControlStyles}>
    <Grid item xs={4}><Typography variant="body1">{label}:</Typography></Grid>
    <Grid item xs={8}>
      {isSelect ? (
        <FormControl fullWidth>
          <Select
            styles={formFieldStyles}
            placeholder={placeholder}
            value={value}
            options={options}
            onChange={onChange}
            menuPosition="fixed"
            isClearable={false}
            isDisabled={disabled}
            onMenuOpen={onMenuOpen}
          />
        </FormControl>
      ) : (
        <TextField
          fullWidth
          variant="outlined"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          slotProps={{ input: getInputProps() }}
          disabled={disabled}
        />
      )}
    </Grid>
  </Grid>
);

export const UpdateModelHrcyDialog = ({ open, onClose, selectedRow, email }) => {
  const dispatch = useDispatch();
  const [kmatId, setKmatId] = useState('');
  const [modelName, setModelName] = useState('');
  const [region, setRegion] = useState(null);
  const [category, setCategory] = useState(null);
  const [series, setSeries] = useState(null);
  const [subCategory, setSubCategory] = useState(null);
  const [seriesOptions, setSeriesOptions] = useState([]);
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);

  useEffect(() => {
    if (selectedRow && open) {
      setKmatId(selectedRow.kmatId || '');
      setModelName(selectedRow.modelName || '');
      setRegion(selectedRow.region || null);
      setCategory(selectedRow.category ? { label: selectedRow.category, value: selectedRow.category } : null);
      setSeries(selectedRow.series ? { label: selectedRow.series, value: selectedRow.series } : null);
      setSubCategory(selectedRow.subCategory ? { label: selectedRow.subCategory, value: selectedRow.subCategory } : null);

      const fetchOptions = async () => {
        if (selectedRow.category) {
          const catValue = selectedRow.category;
          const data = await dispatch(getModelHierarchy({ category: catValue, series: "" }));
          setSeriesOptions((data?.selectedSeries || []).map(s => ({ label: s, value: s })));
          if (selectedRow.series) {
            const subData = await dispatch(getModelHierarchy({ category: catValue, series: selectedRow.series }));
            setSubCategoryOptions((subData?.selectedSubCategory || []).map(sc => ({ label: sc, value: sc })));
          } else {
            setSubCategoryOptions((data?.selectedSubCategory || []).map(sc => ({ label: sc, value: sc })));
          }
        }
      };
      fetchOptions();
    }
  }, [selectedRow, open, dispatch]);

  const handleSeriesMenuOpen = async () => {
    if (category) {
      const data = await dispatch(getModelHierarchy({ category: category.value, series: "" }));
      setSeriesOptions((data?.selectedSeries || []).map(s => ({ label: s, value: s })));
      setSubCategoryOptions((data?.selectedSubCategory || []).map(sc => ({ label: sc, value: sc })));
    }
  };

  const handleSeriesChange = async (selected) => {
    setSeries(selected);
    setSubCategory(null);
    if (category && selected) {
      const data = await dispatch(getModelHierarchy({ category: category.value, series: selected.value }));
      setSubCategoryOptions((data?.selectedSubCategory || []).map(sc => ({ label: sc, value: sc })));
    } else {
      setSubCategoryOptions([]);
    }
  };

  const handleSubCategoryMenuOpen = async () => {
    if (category && series) {
      const data = await dispatch(getModelHierarchy({ category: category.value, series: series.value }));
      setSubCategoryOptions((data?.selectedSubCategory || []).map(sc => ({ label: sc, value: sc })));
    }
  };

  const handleUpdate = () => {
    dispatch(updateModelHierarchy(kmatId, region, series?.value, modelName, email));
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} className='custom-dialog'>
      <DialogTitle variant='h6'>Update Model Hierarchy</DialogTitle>
      <DialogContent>
        <FormField label="Region" value={region} onChange={setRegion} placeholder="Select Region" disabled />
        <FormField label="KMAT ID" value={kmatId} onChange={setKmatId} placeholder="Enter KMAT ID" disabled />
        <FormField label="Category" value={category} onChange={setCategory} options={category ? [category] : []} placeholder="Select Category" isSelect disabled />
        <FormField label="Series" value={series} onChange={handleSeriesChange} options={seriesOptions} placeholder="Select Series" isSelect onMenuOpen={handleSeriesMenuOpen} />
        <FormField label="Model Name" value={modelName} onChange={e => setModelName(e.target.value)} placeholder="Enter Model Name" />
        <FormField label="Sub Category" value={subCategory} onChange={setSubCategory} options={subCategoryOptions} placeholder="Select Sub Category" isSelect onMenuOpen={handleSubCategoryMenuOpen} />
      </DialogContent>
      <DialogActions className='dialog-actions'>
        <Button variant="outlined" className='cancel-button' onClick={onClose}>Cancel</Button>
        <Button variant="outlined" onClick={handleUpdate} className='add-Button'>Update</Button>
      </DialogActions>
    </Dialog>
  );
};